'use es6';

export const selectResultsView = state => state.storefront.resultsView;